import { render, staticRenderFns } from "./TDSError.vue?vue&type=template&id=6f3d2d22&scoped=true&"
import script from "./TDSError.vue?vue&type=script&lang=ts&"
export * from "./TDSError.vue?vue&type=script&lang=ts&"
import style0 from "./TDSError.vue?vue&type=style&index=0&id=6f3d2d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3d2d22",
  null
  
)

export default component.exports